export enum Messages {
  OFFLINE_ATTENDANCE = 'Offline Attendance',
  OFFLINE_ACTIVITY = 'Offline Activity Recording',
  ONLINE_ATTENDANCE = 'Online Attendance',
  SUCCESS_SAVED_ATTENDANCE = 'Hooray! Your attendance has been successfully recorded',
  SUCCESS_SAVED_BREAKTIME = 'Hooray! Your break time has been successfully recorded',
  OUTSIDE_ATTENDANCE_AREA = 'You are outside the location where you are permitted to register your attendance',
  FAILED_SAVED_ATTENDANCE = 'Data failed to send, data saved to offline mode',
  FAILED_SAVED_ATTENDANCE_WITHOUT_OFFLINEMODE = 'Data failed to send',
  SENDING = 'Sending',
  SENDING_ATTENDANCE = 'Sending record attendance',
  SENDING_PHOTO = 'Photo sent',
  SENDING_ACTIVITY = 'Activity Recording sent',
  FAILED_SENDING_PHOTO = 'Photo failed to send',
  UPLOADING_PHOTO = 'Uploading photo',
  SERVER_ERROR = 'Sorry, something went wrong',
  SERVER_ERROR_DESC = 'There was problem connecting to the server',
  NO_INTERNET_CONNECTION = 'No internet connection',
  ATTENDANCE_RECORD = 'Attendance Record',
  ALERTQUEATTENDANCE = 'AlertQueAttendance',
  NOTIF_SYNC_OFFLINE = 'attendance records that has not been sent to Server, please sync the data',
  NOTIF_SYNC_OFFLINE_ACTIVITY = 'activity records that has not been sent to Server, please sync the data',
  THEREARE = 'There are',
  FAILED_TO_SEND = 'Data failed to send',
  SEND_DATA = 'Send data',
  DATA_SEND = 'Data send',
  OF = 'of',
  SUCCESSFULLY_SEND = 'Successfully Send',
  SUCCESSFULLY_SENT = 'Successfully Sent',
  FAILED_SEND = 'Failed to send',
  CHECKING_FACE_DETECTION = 'Checking face detection',
  EXIT_CONFIRM = 'Do you want to exit?',
  CONFIRMATION = 'Confirmation',
  INFORMATION = 'Information',
  NETWORK_DISCONECTED = 'Network was disconnected!!',
  LEAVE_TYPE_HAS_BEEN_USED = 'Leave Type has been Used for Employee Leave',
  YOU_DONT_HAVE_PERMISSION = 'You do not have permission',
  SUCCESSFULLY_DELETED = 'Successfully Deleted',
  SUCCESSFULLY_SAVED = 'Successfully Saved',
  SUCCESSFULLY_UPDATED = 'Successfully Updated',
  SUCCESSFULLY_APPROVE_OVERTIME = 'Successfully Approve Overtime Request',
  SUCCESSFULLY_CANCEL_OVERTIME = 'Successfully Cancel Overtime Request',
  SUCCESSFULLY_REJECT_OVERTIME = 'Successfully Reject Overtime Request',
  SUCCESSFULLY_REVISE_OVERTIME = 'Successfully Revise Overtime Request',
  SUCCESSFULLY_CLOSE_REQUEST = 'Successfully Close Request',
  SUCCESSFULLY = 'Successfully',
  FAILED = 'Failed',
  EFFECTIVE_DATE_MUST_BE_GREATER = 'Effective date must be greater than last Effective Date',
  FAILED_SAVED = 'Failed Saved',
  SUCCESSFULLY_PROFILE_DETAIL_SAVED = 'Your data submitted is successfully saved and on its way for approval.',
  SUCCESSFULLY_APPROVE_PROFILE_REQUEST = 'Successfully Approved Request',
  SUCCESSFULLY_REJECT_PROFILE_REQUEST = 'Successfully Reject Request',
  SUCCESSFULLY_REVISE_PROFILE_REQUEST = 'Successfully Revise Request',
  MSG_REFRESH_SESSION = 'Sorry, looks like you have to refresh your session to keep using GreatDay',
  INVALID_TOKEN = 'Your session has ended',
  SUCCESSFULLY_SUBMIT_REQUEST = 'Successfully Submit Request',
  CANNOT_ALLOWED_RECORD_ATTENDANCE_FROM_WEB = 'Oops, you are not allowed to record attendance from the web, Please contact your admin to allow recording attendance from the web',
  PASSWORD_DIFFERENT = 'Password are different',
  SUCCESSFULLY_RESET_PASSWORD = 'Password Successfully Reset',
  FILE_TYPE_INVALID = 'File type is invalid.',
  SUCCESSFULLY_UPLOADED = 'Successfully Uploaded',
  PANIC_BTN_CONFIRM_REPORT = "Calm down, don't panic. report this issue?",
  CONFIRMATION_DELETE = "Are you sure you want delete this data?",
  CONFIRMATION_DELETE_PHOTO = "Are you sure you want delete this photo?",
  MSG_EXPIRED_SESSION = 'Sorry, looks like you should go back to the login',
  CONFIRM_REMOVE_ACCOUNT = "Are You Sure want to remove this account?",
  CONFIRM_REMOVE_ALL_ACCOUNT = "Are You Sure want to remove all account?",
  ID_GUEST_INVALID = "ID Guest Invalid",
  THIS_FEATURE_NOT_SUPPORT_IOS = "Sorry, this feature cannot be used on iOS devices at the moment",
  DO_NOT_EDIT_BELOW_TEXT = 'Please do not edit the below text',
  CONFIRM_SEND_EMAIL_OFFLINE_MODE = 'You will send an email to greatday support, please do not edit the text in the email',
  USER_CANNOT_OFF_TRACKING = "You cannot turn off the tracking, because you are in shift day",
  SHIFT_BETWEEN_ATTENDANCE_DISABLED = "Check shift between attendance tracker is disabled",
  ONLY_AVAILABLE_DEVICE_PHONE = "Only available on phone device",
  SUCCESSFULLY_SAVE_AS_DRAFT = "  Successfully Save As Draft",
  TRACKING_GOOGLE_PLAYSERVICE_NOT_AVAILABLE = "The feature tracking requires google play service, but the system can't detect google play service on your device",
  TRACKING_NOT_SUPPORT = "Tracking feature does not support this device",
  YESDOK_CONFIRM_MESSAGE = "Layanan ini didukung oleh YesDok<br><br>GreatDay HR akan membagikan data diri Anda kepada YesDok sebatas untuk pembuatan akun. Anda akan otomatis terdaftar sebagai pengguna YesDok dengan <a style='font-weight:bold;' href='https://www.yesdok.com/id/tnc.html'>syarat & ketentuan</a> yang berlaku.",
  YESDOK_CONFIRM_MESSAGE_TERM = "Layanan ini didukung oleh YesDok<br><br>GreatDay HR akan membagikan data diri Anda kepada YesDok sebatas untuk pembuatan akun. Anda akan otomatis terdaftar sebagai pengguna YesDok dengan <a style='font-weight:bold;' class='termYesdok'>syarat & ketentuan</a> yang berlaku.",
  PLEASE_WAIT = "Please wait",
  BENEFIT_NOT_REGISTERED = "Sorry, your company is not registered in this feature. please contact admin.",
  UPDATE_APP_TO_USE_INTERCOM = "Sorry for the inconvenience, the app needs to be updated to use chat support. Please update to version",
  FORCE_UPDATE_APP_BY_COMPANY = "Sorry for the inconvenience, the app needs to be updated to get the latest features, improvements, and bug fixes. Please update to version",
  UPDATE_APP = "Please update app to get the latest features, improvements, and bug fixes",
  WARNING_ROOT_JAILBREAK = "You cannot use this application because this device has been detected as rooted/jailbroken",
  WARNING_ATTENDANCE_ROOT_JAILBREAK = "You cannot record attendance because this device has been detected as rooted/jailbroken",
  WARNING_FOR_USE_SIM_CARD = "Sorry, you have to use a sim card to be able to use this application!",
  WARNING_ALLOW_PERMISSION_PHONE = "Sorry, you must activate phone permissions to use this application!",
  MESSAGE_FACE_SPOOFING = "No face detected, Please take another photo",
  CONFIRM_SEND_OFFLINE_ATTENDANCE = 'You have offline attendance data that has not been sent to the server, do you want to send it now?'
}



// WEBPACK FOOTER //
// ./src/helpers/messages.ts